import consentLinks from "../const/consentLinks";
var getConsentLinks = function (lang) {
    return consentLinks[lang].href;
};
export default getConsentLinks;
